export default "__VITE_ASSET__2cdcfb2c__"